import { useEffect, useState } from "react";
import { Button, Flex, Text } from "@radix-ui/themes";
import { useI18n } from "@/i18n";
import { todayISO } from "@/lib/dates";

interface DateRangeInputsProps {
  from: string;
  to: string;
  onApply: (from: string, to: string) => void;
}

export function DateRangeInputs({ from, to, onApply }: DateRangeInputsProps) {
  const { t } = useI18n();
  const [draftFrom, setDraftFrom] = useState(from);
  const [draftTo, setDraftTo] = useState(to);

  // Keep the draft in sync when the committed range changes elsewhere (e.g. category switch).
  useEffect(() => setDraftFrom(from), [from]);
  useEffect(() => setDraftTo(to), [to]);

  const isValidRange = draftFrom !== "" && draftTo !== "" && draftFrom <= draftTo;
  const isUnchanged = draftFrom === from && draftTo === to;
  const max = todayISO();

  return (
    <Flex align="end" gap="3" wrap="wrap" className="rk-date-range">
      <label className="rk-field">
        <Text as="div" size="1" color="gray" mb="1">
          {t("picker.from")}
        </Text>
        <input
          type="date"
          className="rk-date-input"
          value={draftFrom}
          max={draftTo || max}
          onChange={(e) => setDraftFrom(e.target.value)}
        />
      </label>
      <label className="rk-field">
        <Text as="div" size="1" color="gray" mb="1">
          {t("picker.to")}
        </Text>
        <input
          type="date"
          className="rk-date-input"
          value={draftTo}
          min={draftFrom}
          max={max}
          onChange={(e) => setDraftTo(e.target.value)}
        />
      </label>
      <Button
        size="2"
        disabled={!isValidRange || isUnchanged}
        onClick={() => onApply(draftFrom, draftTo)}
      >
        {t("picker.apply")}
      </Button>
    </Flex>
  );
}
